import React from 'react';
import { Truck } from 'lucide-react';

const PageFrame = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-12 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Framed Container */}
        <div className="relative border-2 border-gray-300 dark:border-gray-700 rounded-2xl bg-white dark:bg-gray-800 shadow-xl overflow-hidden">
          {/* Watermark Logo - Top Left */}
          <div className="absolute top-4 left-4 flex items-center gap-2 opacity-20 pointer-events-none">
            <Truck className="h-8 w-8 text-orange-500" />
            <span className="text-lg font-bold text-gray-400 dark:text-gray-600">TruckAccidentSupport</span>
          </div>
          
          {/* Corner Decorations */}
          <div className="absolute top-0 left-0 w-16 h-16 border-t-4 border-l-4 border-orange-500 rounded-tl-2xl" />
          <div className="absolute top-0 right-0 w-16 h-16 border-t-4 border-r-4 border-orange-500 rounded-tr-2xl" />
          <div className="absolute bottom-0 left-0 w-16 h-16 border-b-4 border-l-4 border-orange-500 rounded-bl-2xl" />
          <div className="absolute bottom-0 right-0 w-16 h-16 border-b-4 border-r-4 border-orange-500 rounded-br-2xl" />
          
          {/* Content */}
          <div className="pt-16 pb-12 px-6 md:px-12">
            {/* Header */}
            {(title || subtitle) && (
              <div className="text-center mb-10">
                {title && (
                  <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-3">
                    {title}
                  </h1>
                )}
                {subtitle && (
                  <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
                    {subtitle}
                  </p>
                )}
              </div>
            )}
            
            {/* Page Content */}
            {children}
          </div>
          
          {/* Bottom Watermark */}
          <div className="absolute bottom-4 right-4 flex items-center gap-2 opacity-10 pointer-events-none">
            <Truck className="h-6 w-6 text-orange-500" />
            <span className="text-sm font-medium text-gray-400">truckaccidentsupport.com</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageFrame;
